import { createFileRoute, redirect } from "@tanstack/react-router";

const legacyGuideSlugs: Record<string, "/guias/pequenas-bolinhas-no-penis" | "/guias/bolhas-na-cabeca-do-penis"> = {
  "small-bumps-on-penis": "/guias/pequenas-bolinhas-no-penis",
  "bumps-on-penis-head": "/guias/bolhas-na-cabeca-do-penis",
};

export const Route = createFileRoute("/guides/$slug")({
  beforeLoad: ({ params }) => {
    const target = legacyGuideSlugs[params.slug] ?? "/guias/pequenas-bolinhas-no-penis";
    throw redirect({ to: target, statusCode: 301 });
  },
});